/* eslint-disable no-console */

const RANDOM_KEY = 'test-random-12345';

/** Test if local storage is available, could be disabled by the user */
export const isLocalStorageSupported = () => {
  try {
    localStorage.setItem(RANDOM_KEY, 'test');
    localStorage.removeItem(RANDOM_KEY);
    return true;
  } catch {
    return false;
  }
};

/** Test if session storage is available, could be disabled by the user */
export const isSessionStorageSupported = () => {
  try {
    sessionStorage.setItem(RANDOM_KEY, 'test');
    sessionStorage.removeItem(RANDOM_KEY);
    return true;
  } catch {
    return false;
  }
};

/**
 * A sessionStorage wrapper for accessing safely without thrown errors if disabled by user
 */
export const safeSessionStorage: typeof sessionStorage = {
  length: 0,
  clear: function (): void {
    try {
      sessionStorage.clear();
    } catch (e) {
      console.warn(`Safe Session Storage - Failed to execute operation clear`, e);
    }
  },
  getItem: function (key: string): string | null {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      console.warn(`Safe Session Storage - Failed to execute operation getItem`, e);
      return null;
    }
  },
  key: function (index: number): string | null {
    try {
      return sessionStorage.key(index);
    } catch (e) {
      console.warn(`Safe Session Storage - Failed to execute operation key`, e);
      return null;
    }
  },
  removeItem: function (key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      console.warn(`Safe Session Storage - Failed to execute operation removeItem`, e);
    }
  },
  setItem: function (key: string, value: string): void {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      console.warn(`Safe Session Storage - Failed to execute operation setItem`, e);
    }
  },
};

/**
 * A localStorage wrapper for accessing safely without thrown errors if disabled by user
 */
export const safeLocalStorage: typeof localStorage = {
  length: 0,
  clear: function (): void {
    try {
      localStorage.clear();
    } catch (e) {
      console.warn(`Safe Local Storage - Failed to execute operation clear`, e);
    }
  },
  getItem: function (key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.warn(`Safe Local Storage - Failed to execute operation getItem`, e);
      return null;
    }
  },
  key: function (index: number): string | null {
    try {
      return localStorage.key(index);
    } catch (e) {
      console.warn(`Safe Local Storage - Failed to execute operation key`, e);
      return null;
    }
  },
  removeItem: function (key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.warn(`Safe Local Storage - Failed to execute operation removeItem`, e);
    }
  },
  setItem: function (key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      console.warn(`Safe Local Storage - Failed to execute operation setItem`, e);
    }
  },
};
